enum ActivityType {
    Task = 'task',
    Event = 'event',
}

export default ActivityType;
